import { Typography } from '@mui/material';

import colors from 'common/constants/colors';
import { CATALOG_DISABLED_LABEL } from 'common/constants/catalogStatus';

// POM-6309: builds the MUI renderOption callback for the pickers whose options are plain label
// strings, resolving each label back to its group so a catalog product disabled for ordering can be
// marked. The marker is informational and never blocks selection — these screens work orders that
// already exist, and such an order is exactly what a disabled product is still needed for.
//
// The <li> is returned directly rather than from a wrapper component: MUI puts the list key on the
// props it hands in, so it has to land on the element this callback returns.
export const buildCatalogProductOptionRenderer = (optionGroups) => {
  const renderCatalogProductOption = (optionProps, label) => {
    const { key, ...liProps } = optionProps;
    const group = optionGroups.find((candidate) => candidate.label === label);
    const isCatalogEnabled = group?.isCatalogEnabled !== false;

    return (
      // eslint-disable-next-line react/jsx-props-no-spreading
      <li key={key} {...liProps}>
        <Typography variant='body2'>{label}</Typography>
        {/* Deliberately lighter than the chip the association pickers use. There the status changes
            what gets dispensed, so it earns the weight; here the user is only narrowing a list and
            nothing is written, so a quiet word is enough. */}
        {!isCatalogEnabled && (
          <Typography
            variant='caption'
            sx={{
              ml: 1,
              whiteSpace: 'nowrap',
              alignSelf: 'center',
              // Not color='warning.main': this theme maps that to perfectRxBlue, and a blue word
              // inside a clickable option reads as a second thing to click.
              color: colors.warningAmberText,
            }}
          >
            {CATALOG_DISABLED_LABEL}
          </Typography>
        )}
      </li>
    );
  };

  return renderCatalogProductOption;
};

export default buildCatalogProductOptionRenderer;
